const pagesAccessesEn = {
  filter: {
    date: 'Date',
    device: 'Device',
    export: {
      disabledTab:
        'Export is available only on the Registered Software or All tab.',
    },
    id: 'ID',
    people: 'People',
    placeholder: 'Filter...',
    software: 'Software',
  },
  help: {
    shadowID: {
      text: 'These are access logs for try login to ID that is not connected to DRESS CODE, collected via the browser extension.<br />They are updated every hour, at the top of each hour.',
      title: 'Shadow Identity?',
    },
    shadowIt: {
      text: 'These are access logs to software that is not connected to DRESS CODE, collected via the browser extension.<br />They are updated every hour, at the top of each hour.',
      title: 'Shadow IT?',
    },
  },
  // 一覧画面
  nav: {
    alerts: 'Alerts',
    contractAndCost: 'Contract & Cost',
    logs: 'Logs',
    overview: 'Overview',
    settings: 'Settings',
    software: 'Software',
  },
  productHeader: {
    pageTitle: 'Accesses',
  },
  table: {
    accessedTo: 'Accessed to',
    action: 'Action',
    device: 'Device',
    id: 'ID',
    timestamp: 'Timestamp',
    visit: 'Visit',
    whoAccessed: 'Who accessed',
  },
  tabs: {
    all: 'All',
    blocked: 'Blocked IT Services',
    registered: 'Registered Software',
    tolerated: 'Tolerated IT Services',
  },

  // アラート画面
  alerts: {
    filter: {
      category: 'Category',
      itService: 'IT Service',
      member: 'Member',
      placeholder: 'Filter...',
    },
    sideTabs: {
      closeSideTab: 'Close side tab',
      dormantAI: 'Dormant AI',
      dormantID: 'Dormant ID',
      dormantIT: 'Dormant IT',
      shadowAI: 'Shadow AI',
      shadowID: 'Shadow Identity',
      shadowIT: 'Shadow IT',
    },
    summary: {
      fromLastMonth: 'from last month',
      help: {
        totalAccessCount:
          'The total number of accesses collected this month from browsers with the browser extension installed.',
        uniqueMemberCount:
          'The number of unique users who accessed from browsers with the browser extension installed this month.',
        uniqueShadowID:
          'The total number of shadow identities detected from the past up to this month.',
        uniqueShadowIT:
          'The total number of shadow IT services detected from the past up to this month.',
      },
      totalAccessCount: 'Monthly unique accesses',
      uniqueMemberCount: 'Monthly accessed people',
      uniqueShadowID: 'Detected Shadow Identity',
      uniqueShadowIT: 'Detected Shadow IT',
    },
    table: {
      access7Days: '7-day total access count',
      access30Days: '30-day total access count',
      category: 'Category',
      itService: 'IT Service',
      members: 'Members',
      uniqueUserCount: 'Unique user count',
    },
    unknownUser: 'Unknown user',
  },

  list: {
    backToList: 'Back to list',
  },

  alertDetail: {
    breadcrumb: 'Accesses',
    filter: {
      placeholder: 'Filter...',
    },
    pageTitle: 'Alert Detail',
  },

  dormancy: {
    filter: {
      placeholder: 'Filter...',
    },
    help: {
      text: 'Accounts with no login within the configured period (counting back from the current month) are detected as dormant candidates.<br />Example: As of April 13<br />・1 month → Before March 1 (= no login in March or April)<br />・2 months → Before February 1 (= no login in February, March, or April)',
      title: 'How dormancy detection works',
    },
    summary: {
      affectedSoftwareCount: 'Affected Software',
      connectedSaaS: 'Connected SaaS',
      customSetting: 'Custom Setting',
      defaultSetting: 'Default Setting',
      dormantAccountCount: 'Dormant Candidates',
      fromLastMonth: 'from last month',
      help: {
        affectedSoftwareCount:
          'Number of software with dormant candidates detected.',
        dormantAccountCount:
          'Total number of dormant candidates detected across all connected software.',
        dormantRate:
          'Percentage of dormant candidates. Excluded and suspend candidate accounts are not included.',
        threshold:
          'Accounts with no login by the beginning of the target month are detected as dormant candidates.',
      },
      monthUnit: 'months',
      threshold: 'Detection Criteria',
    },
  },

  dormancyDetail: {
    breadcrumb: 'Back to software list',
    bulkAction: {
      bulkExclude: 'Bulk exclude selected',
      bulkRemoveExclude: 'Remove exclusion',
      bulkSuspend: 'Bulk suspend selected',
      bulkUnsuspend: 'Unsuspend selected',
      selectedCount: '{{count}} selected',
    },
    dormantDays: '{{count}} days',
    filter: {
      dormantDays: 'Dormant days',
      pattern: 'Pattern',
    },
    header: {
      activeUserCount: 'Active accounts',
      dormantCount: 'Dormant candidates',
      software: 'Software',
      title: 'User List',
    },
    pattern: {
      alumni: 'Alumni',
      invited: 'Invited',
      lowFrequency: 'Low frequency',
      onLeave: 'On leave',
      unused: 'Unused',
    },
    rowAction: {
      excludeFlag: 'Exclude',
      removeExclude: 'Remove exclusion',
      suspendFlag: 'Suspend candidate',
      unsuspend: 'Unsuspend',
    },
    tab: {
      alert: 'Alert',
      excluded: 'Excluded',
      suspendCandidate: 'Suspend candidate',
    },
    toast: {
      excludeSuccess: 'Exclusion flag set',
      removeSuccess: 'Exclusion removed',
      suspendSuccess: 'Marked as suspend candidate',
    },
  },

  dormancySettings: {
    description:
      'Detection is based on last login of active accounts. Suspended accounts are always excluded.',
    excludeInvitedAccounts: 'Exclude Invited Accounts',
    excludeInvitedAccountsDescription:
      'When ON, invited accounts that have not yet started usage will be excluded from dormancy detection.',
    lastLoginThreshold: 'Dormancy Detection Criteria',
    lastLoginThresholdDescription:
      'Accounts with no login by the beginning of the target month are detected as dormant candidates.',
    loadError: 'Failed to load settings. Please try again later.',
    oneMonth: '1 Month',
    pageTitle: 'Settings',
    save: 'Save Settings',
    saveSuccess: 'Settings saved successfully',
    sectionTitle: 'Dormant IT Detection Settings',
    toggleOff: 'OFF',
    toggleOn: 'ON',
    twoMonths: '2 Months',
  },

  gwsAuditLogSettings: {
    columns: {
      actions: '',
      appIntegration: 'Integration',
      enabled: 'Enabled',
      status: 'Status',
    },
    description:
      'Collect audit logs from Google Workspace and display them on the access log screen.',
    disable: {
      confirmDescription:
        'Audit log collection will stop. Existing collected logs will remain.',
      confirmOk: 'Disable',
      confirmTitle: 'Disable Google Workspace audit log integration?',
    },
    enable: {
      confirmDescription:
        'You will be redirected to the Google consent screen to grant audit log read permission. Please sign in with a Google Workspace administrator account.',
      confirmOk: 'Connect',
      confirmTitle: 'Enable Google Workspace audit log integration?',
    },
    expandButton: {
      collapse: 'Hide details',
      expand: 'Show details',
    },
    notInstalled: {
      linkLabel: 'Go to integration settings',
      message: 'Please connect Google Workspace first.',
    },
    sectionTitle: 'Google Workspace Audit Log Integration',
    status: {
      connected: 'Connected',
      disabled: 'Disabled',
      needsReauth: 'Insufficient permission',
    },
    tenantCount_one: '{{count}} tenant',
    tenantCount_other: '{{count}} tenants',
    toast: {
      disableSuccess: 'Disabled successfully',
    },
    toggle: {
      off: 'OFF',
      on: 'ON',
    },
    warning: {
      missingScope:
        'Additional permission is required. Please re-authenticate.',
      reauthButton: 'Reconnect',
    },
  },

  settings: {
    pageTitle: 'Settings',
  },

  pagination: {
    of: 'of',
    page: 'Page',
    rows: 'rows',
    rowsPerPage: 'Rows per page',
  },
};

export default pagesAccessesEn;
